import { render, staticRenderFns } from "./IncomingDocumentAttachmentDetailUpload.vue?vue&type=template&id=c8be427c"
import script from "./IncomingDocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"
export * from "./IncomingDocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports